export default "__VITE_ASSET__DkBSZ9g9__"